import {createContext} from "react";

export const EnvironmentSettingsContext = createContext({
    settings: {},
    getSetting: (key, defaultValue=undefined) => {},
});
